/* LOS TITULARES SE REVELAN LÍNEA POR LÍNEA · 27-ago-2026
 *
 * 🔴 QUÉ PROBLEMA RESUELVE. Hasta hoy los titulares entraban como todo lo
 * demás: opacidad y 18-28px de subida, el mismo gesto que un párrafo o una
 * tarjeta. Funciona, pero no se NOTA — es el movimiento genérico de cualquier
 * plantilla con scroll reveal, y en una tipografía de display de 3rem se
 * desperdicia lo único que esa tipografía tiene de especial: sus líneas.
 *
 * 🔴 LO QUE HACE ES UNA CORTINA POR RENGLÓN. Cada línea del titular se mete en
 * una caja que recorta, y el texto sube desde abajo de esa caja. No aparece: se
 * DESCUBRE, como si alguien levantara una persiana renglón a renglón. Es el
 * gesto que usan las casas editoriales —Tôtemé revela su menú con `clip-path`
 * por la misma razón— y es caro de imitar con una plantilla, que es
 * exactamente el punto.
 *
 * 🔴 HAY QUE ESPERAR A LAS FUENTES. Si se parte antes de que Fraunces/Melodrama
 * carguen, las líneas se calculan con la fuente de respaldo y quedan mal
 * cortadas — un renglón con una palabra suelta, o cinco líneas donde hay tres.
 * `document.fonts.ready` es innegociable aquí.
 *
 * 🔴 Y SE VUELVE A PARTIR AL CAMBIAR DE ANCHO. Girar el teléfono cambia dónde
 * cae cada corte de línea; sin re-partir, las cajas de recorte quedan a la
 * altura vieja y el texto sale cortado por la mitad.
 *
 * ⚠️ ACCESIBILIDAD: el texto sigue siendo texto, en su orden, dentro de spans.
 * Un lector de pantalla lo lee igual. No se usa `aria-label` a mano justamente
 * para no tener dos fuentes de verdad que se puedan desincronizar.
 */
(function () {
  'use strict';

  /* 🔴 EL MÓDULO SE MARCA SOLO SUS TITULARES, en vez de pedir `data-lineas` en
     cada sección Liquid. Son seis archivos distintos y cada edición de Liquid
     es una oportunidad de romper algo; aquí la lista vive en un solo sitio y se
     cambia sin volver a tocar el tema.
     ⚠️ SOLO la serif de display. Aplicarlo a un `<p>` o a un rótulo en
     versalitas convierte el gesto en un tic: si TODO se descubre renglón a
     renglón, ya no se descubre nada. */
  var CANDIDATOS = '.h-slide__titulo, .a-h2, .c-cabeza__n, .f-nombre';
  var SEL = '[data-lineas]';

  function quieto() {
    return window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* Deshacer el reparto y dejar el titular COMO ESTABA — no como texto pelado.
     ⚠️ El markup original de las secciones envuelve el titular en un `<span>`,
     y el revelado viejo de `avora-home.css` anima justo ese `> span`. Al
     revertir con `textContent` se pierde, y el titular queda visible pero
     MUERTO: sin reparto y sin el gesto que ya tenía. Se vio en vivo el 27-ago
     en cuatro de los seis titulares del home. Devolver el span cuesta tres
     líneas; no devolverlo se ve como una animación que "a veces no sale". */
  function revierte(el, texto) {
    if (el.getAttribute('data-entra') === 'titulo') {
      el.textContent = '';
      var s = document.createElement('span');
      s.textContent = texto;
      el.appendChild(s);
    } else {
      el.textContent = texto;
    }
    el.removeAttribute('data-partido');
    el.removeAttribute('data-lineas');
  }

  /* Parte el titular en líneas REALES — las que el navegador acabó dibujando,
     no las que uno supone. Se envuelve cada palabra, se lee a qué altura quedó
     y se agrupan las que comparten altura. */
  function parte(el) {
    var texto = el.getAttribute('data-texto');
    if (texto == null) {
      texto = el.textContent.replace(/\s+/g, ' ').trim();
      el.setAttribute('data-texto', texto);   /* el original, para re-partir */
    }

    /* 🔴 HAY QUE CLAVAR EL ANCHO ANTES DE VACIAR, O SE MIDE CONTRA UNA MENTIRA.
       Estos titulares viven en contenedores que se ajustan al contenido. Al
       poner `textContent = ''` el contenedor se queda sin nada que medir y
       COLAPSA; las palabras que se van metiendo después se envuelven contra ese
       ancho encogido, y se registran renglones que el navegador nunca dibujó.
       Medido el 27-ago en el catálogo: "Todo el catálogo" ocupaba 164px en UN
       renglón, y salía partido en TRES sobre un contenedor de 112px —"Todo",
       "el", "catálogo"— porque la medición se hizo contra el hueco vacío.
       Fijar el ancho real durante la medición y soltarlo al terminar cuesta dos
       líneas y es la diferencia entre partir bien y romper la maqueta. */
    var caja = el.getBoundingClientRect();
    var anchoReal = caja.width;
    var altoAntes = caja.height;          /* la vara de medir del guardián */

    /* 🔴 MEDIO PÍXEL DE HOLGURA, O EL TITULAR SE PARTE DONDE NO SE PARTÍA.
       Estos titulares viven en contenedores que se ajustan al texto: el ancho
       de la caja ES el ancho del texto, al decimal. Al meter una palabra por
       `<span>`, cada span redondea su propio ancho y la suma desborda el
       contenedor por una fracción de píxel — y el navegador manda la última
       palabra a un renglón nuevo que nunca existió. Medido el 27-ago: "Qué
       estás buscando" cabía en 249px y salía en dos renglones sobre 249px.
       Un píxel de holgura durante la medición lo arregla y no puede cambiar
       un corte real: ninguna palabra cabe o deja de caber por medio píxel. */
    el.style.width = Math.ceil(anchoReal + 0.5) + 'px';

    /* 🔴 Y HAY QUE APAGAR EL REVELADO VIEJO MIENTRAS SE MIDE. `avora-home.css`
       ya traía su propio gesto para los titulares de sección:
       `[data-entra="titulo"] > span { display: block; translateY(110%) }`.
       Mis palabras entran como hijas directas del h2, así que esa regla las
       convertía en BLOQUES y cada palabra se registraba como un renglón:
       "Acaba de llegar" medía tres líneas donde hay una, el guardián veía la
       altura cambiada y revertía. Los seis titulares de sección se quedaron
       sin efecto por esto — el síntoma (un revelado que no aparece) no se
       parecía en nada a la causa (dos sistemas de revelado peleándose). */
    el.setAttribute('data-midiendo', '');

    var palabras = texto.split(' ');
    el.textContent = '';
    var marcas = palabras.map(function (p, i) {
      var s = document.createElement('span');
      s.textContent = p + (i < palabras.length - 1 ? ' ' : '');
      el.appendChild(s);
      return s;
    });

    /* Agrupar por altura. Se redondea porque dos palabras del mismo renglón
       pueden diferir en una fracción de píxel. */
    var lineas = [];
    var alturaPrevia = null;
    marcas.forEach(function (s) {
      var y = Math.round(s.offsetTop);
      if (alturaPrevia === null || Math.abs(y - alturaPrevia) > 2) {
        lineas.push([]); alturaPrevia = y;
      }
      lineas[lineas.length - 1].push(s.textContent);
    });

    el.textContent = '';
    lineas.forEach(function (palabrasDeLinea, i) {
      var caja = document.createElement('span');
      /* 🔴 `a-renglon` Y NO `a-linea`: EL NOMBRE YA ESTABA TOMADO. `avora-base.css`
         define `.a-linea { border-top: 1px solid var(--linea) }` — es la regla
         horizontal del sitio. Mi caja heredó ese borde y cada renglón del
         titular salió con una raya encima. Se vio en el catálogo antes de
         detectarlo: "Todo el catálogo" con un filete de 1px sobre las letras.
         Antes de inventar una clase, buscarla en la hoja base. */
      caja.className = 'a-renglon';
      var dentro = document.createElement('span');
      dentro.className = 'a-renglon__i';
      dentro.style.setProperty('--i', i);
      dentro.textContent = palabrasDeLinea.join('');
      caja.appendChild(dentro);
      el.appendChild(caja);
    });

    /* Se suelta el ancho: dejarlo clavado congelaría el titular al ancho que
       tenía en esta medición y dejaría de responder al contenedor. */
    el.style.width = '';
    el.removeAttribute('data-midiendo');

    /* Un solo renglón no tiene nada que DESCUBRIR renglón a renglón: el gesto
       queda idéntico al revelado de bloque que ya existe. Se devuelve el texto
       plano y que lo anime el sistema viejo, sin DOM de más. */
    if (lineas.length < 2) {
      revierte(el, texto);
      return 0;
    }

    /* 🔴🔴 EL GUARDIÁN: SI PARTIR CAMBIÓ LA ALTURA, SE DESHACE.
       Este efecto ya rompió la maqueta DOS veces por el mismo motivo —medir el
       ancho contra un contenedor que en ese instante no era el definitivo— y
       cada vez el síntoma apareció lejos de la causa. La segunda fue en el
       sitio ya publicado: "Todo el catálogo" partido en TRES renglones, 93px
       donde había 34, y las 54 prendas bajando 59px un segundo después de
       cargar. O sea que la animación bonita era la mayor fuente de brinco de
       toda la página.

       En vez de perseguir cada contenedor raro, se comprueba el RESULTADO: si
       el titular no mide lo mismo que antes de tocarlo, el reparto está mal y
       se devuelve el texto tal cual. Se pierde el revelado en ese titular
       —nadie lo echa de menos— y la maqueta queda intacta, que es lo que sí se
       nota. Un adorno nunca puede mover el contenido. */
    var altoDespues = el.getBoundingClientRect().height;
    if (Math.abs(altoDespues - altoAntes) > 2) {
      revierte(el, texto);
      return 0;
    }

    el.setAttribute('data-partido', '');
    return lineas.length;
  }

  function prepara() {
    [].slice.call(document.querySelectorAll(CANDIDATOS)).forEach(function (h) {
      /* Un titular de una sola palabra no tiene renglones que descubrir: el
         gesto se vuelve un simple deslizamiento y no vale el DOM extra. */
      if (h.textContent.trim().split(/\s+/).length < 2) return;
      h.setAttribute('data-lineas', '');
    });

    var titulares = [].slice.call(document.querySelectorAll(SEL));
    if (!titulares.length) return;

    if (quieto()) {
      /* Sin movimiento no se parte siquiera: partir cambia el DOM sin ninguna
         ganancia, y con `text-wrap: balance` puede hasta empeorar el corte. */
      titulares.forEach(function (t) { t.setAttribute('data-revelado', ''); });
      return;
    }

    /* 🔴🔴 EL QUE YA ESTÁ EN PANTALLA SE MARCA REVELADO **ANTES** DE PARTIRLO.
       Primero lo hice al revés —partir y marcar en el mismo tick— confiando en
       que sin dos fotogramas distintos la transición no arrancaría. No basta:
       `parte()` fuerza una medición al final (el guardián comprueba la altura),
       y entre medias el navegador puede pintar el estado sin revelar. Paco lo
       volvió a cazar en una captura: la primera línea puesta y la segunda aún
       escondida dentro de su caja.
       Marcándolo ANTES, los renglones NACEN en su sitio: no existe un estado
       inicial que pintar, así que no hay nada que se pueda colar. Deja de
       depender de cómo el navegador agrupe el trabajo, que es de lo que nunca
       hay que depender. */
    titulares.forEach(function (t) {
      var caja = t.getBoundingClientRect();
      if (caja.top < innerHeight && caja.bottom > 0) t.setAttribute('data-revelado', '');
    });

    titulares.forEach(parte);

    /* 🔴🔴 LO QUE YA ESTÁ EN PANTALLA NO SE ANIMA: SE DA POR REVELADO.
       Este módulo corre en `document.fonts.ready`, que llega DESPUÉS del primer
       pintado. O sea que el titular de portada ya se vio —entero, como texto
       plano— y un instante más tarde se partía, se escondía dentro de sus
       cajas y volvía a subir. No es la animación: es la animación EMPEZANDO
       TARDE, y desde fuera se lee como un parpadeo o como un titular cortado a
       la mitad. Paco lo cazó en una captura el 28-ago entrando a la portada
       desde el menú.

       El arreglo no es acelerar nada: es no animar lo que el ojo ya vio. Se
       marca revelado en el MISMO tick en que se parte, así que entre un pintado
       y el siguiente no hay ningún estado intermedio que mostrar — y como la
       transición necesita dos fotogramas distintos para arrancar, tampoco corre.
       El gesto se conserva íntegro donde tiene sentido: en todo lo que aún está
       por debajo del pliegue y va a entrar con el scroll. */
    var ojo = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.setAttribute('data-revelado', '');
        ojo.unobserve(e.target);          /* una sola vez: no revierte */
      });
    }, { rootMargin: '0px 0px -12% 0px' });

    titulares.forEach(function (t) {
      if (t.hasAttribute('data-revelado')) return;   /* ya se vio: sin gesto */
      ojo.observe(t);
    });

    /* Re-partir al cambiar el ancho. Solo el ANCHO: en celular, mover la barra
       del navegador cambia el alto constantemente y re-partir ahí sería
       recalcular decenas de veces mientras la clienta hace scroll. */
    var anchoPrevio = window.innerWidth;
    var reloj = null;
    addEventListener('resize', function () {
      if (window.innerWidth === anchoPrevio) return;
      anchoPrevio = window.innerWidth;
      if (reloj) clearTimeout(reloj);
      reloj = setTimeout(function () {
        titulares.forEach(function (t) {
          var yaEstaba = t.hasAttribute('data-revelado');
          parte(t);
          /* Si ya se había revelado, se queda revelado: volver a animarlo
             porque alguien giró el teléfono es ruido, no una entrada. */
          if (yaEstaba) t.setAttribute('data-revelado', '');
        });
      }, 180);
    });
  }

  /* 🔴 `document.fonts.ready` O LAS LÍNEAS SE CORTAN DONDE NO VAN. */
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(prepara);
  } else {
    addEventListener('load', prepara);
  }
})();
